// Retroalimentación sensorial (sonido + vibración) para cada acción completada
// del proceso: entrada, inspección, ticket, salida, aprobar, etc.
// No depende de archivos de audio externos (funciona offline): genera los
// tonos con la Web Audio API.

let audioCtx = null;
function getCtx() {
  if (!audioCtx) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioCtx = new Ctx();
  }
  if (audioCtx.state === 'suspended') audioCtx.resume();
  return audioCtx;
}

function tone(freq, start, duration, type = 'sine', gain = 0.15) {
  const ctx = getCtx();
  if (!ctx) return;
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.value = gain;
  osc.connect(g);
  g.connect(ctx.destination);
  osc.start(ctx.currentTime + start);
  g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + duration);
  osc.stop(ctx.currentTime + start + duration + 0.02);
}

function vibrate(pattern) {
  if (navigator.vibrate) {
    try { navigator.vibrate(pattern); } catch (e) { /* ignore */ }
  }
}

export const feedback = {
  // Acción completada con éxito: entrada guardada, salida registrada,
  // inspección enviada, ticket creado, sello colocado, etc.
  success: () => {
    tone(880, 0, 0.12);
    tone(1320, 0.1, 0.15);
    vibrate([90]);
  },

  // Acción completada pero requiere atención (ej. inspección con hallazgo "malo")
  warning: () => {
    tone(660, 0, 0.15, 'triangle', 0.18);
    tone(660, 0.2, 0.15, 'triangle', 0.18);
    vibrate([120, 80, 120]);
  },

  // Error al guardar / sincronizar
  error: () => {
    tone(220, 0, 0.25, 'sawtooth', 0.15);
    vibrate([200]);
  },

  // Guardado local (offline, en cola de sincronización)
  queued: () => {
    tone(520, 0, 0.1, 'sine', 0.12);
    vibrate([50, 40, 50]);
  },
};
